module.exports = __webpack_public_path__ + "static/media/lp-plan-04.8be5b597.png";